
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'
import { M } from './_elementComps/M'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Es gibt mehr als 360 verschiedene Formen von Kopfschmerz. Über 90 Prozent der
Betroffenen leiden aber an Migräne oder Spannungskopfschmerzen. Oft handelt es
sich auch um eine Mischform aus beidem: Die meisten Kopfwehgeplagten haben nicht
nur einen Typ von Kopfschmerz. Etwa eine bis zwei von hundert Personen haben
Monat für Monat mehr Kopfschmerztage als Tage ohne Kopfschmerzen.`}</p>
    <p>{`Viele Betroffene wissen gar nicht, welche Art von Kopfschmerz sie plagt. Folglich
erhalten sie auch nicht die optimale Behandlung. Höchstens fünf von zehn an
Migräne Leidenden ist zum Beispiel klar, dass sie Migräne haben. Wird die
Diagnose «Migräne» gestellt, werden meist auch wirksamere Medikamente eingesetzt
– von denen Kranke früher nur träumen konnten.`}</p>
    <Image className='bigImage' file={[require('images/grafik_migraeneundandere_mobile.svg'), require('images/grafik_migraeneundandere.svg')]} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;